import { BaseModal } from '@itm/shared-frontend/lib/components/modals';

import { useProductVersionWatcher } from 'src/hooks/useProductVersionWatcher';

function NewVersionModal() {
  const { isShowNotice, dismiss, reload } = useProductVersionWatcher();

  return (
    <BaseModal
      isShowModal={isShowNotice}
      closeModal={dismiss}
      Header={<h2 className="modal-card-title has-text-interact has-text-weight-medium">New version available</h2>}
      Body={
        <div className="is-size-4 mb-5 has-text-centered">
          <p className="mb-2">
            A new version of Data Transformation has been released. Please reload the page to make sure you don't miss
            any updates.
          </p>
          <p className="mb-2">Any unsaved changes will be lost.</p>
        </div>
      }
      Footer={
        <div className="is-flex is-justify-content-center">
          <button className="button is-interact mr-3" type="button" onClick={reload}>
            Reload now
          </button>
          <button className="button" type="button" onClick={dismiss}>
            Later
          </button>
        </div>
      }
    />
  );
}

export default NewVersionModal;
